import TextField from "@mui/material/TextField";

interface ITextInput {
    defaultValue?: string;
    label: string;
    id: string;
    value?: string;
    handle?: (value: string) => void;
}

export const TextInput = (prop: ITextInput) => {
    const id = prop.id
    const value = prop.value

    const handleChange = (e: any) => {
       
        if (prop.handle) {
            prop.handle(e.target.value)
        }
    }
    return (
        <TextField 
        defaultValue={prop.defaultValue}
        fullWidth 
        value={value}
        color="secondary" 
        id={id} 
        label={prop.label} 
        variant="outlined" 
        size='small'
        onChange={(e) => handleChange(e)}
        />
        
    )
}